import API from "shared/services/Api";
import { IInsurance } from "shared/types";

export const getInsurance = async (): Promise<IInsurance> =>
  API.get("insurance");
